import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkSpecialDocumentTypeWithCountryExistRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const country = control.get('country')!.value;
	const documentCategory = control.get('documentCategory')!.value;

	return documentType ===  "EGD018"  && documentCategory !==  "EGD02" && !country ? { checkSpecialDocumentTypeWithCountryExistFlag: true } : null;
};
